function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import HubspotContactFormFields from "segments/desktop/core-components/hubspot-contact-form/fields-config";
import AssetFieldsConfig from "components/core/asset/fields-config";
export default {
    type: FIELD_TYPES.NESTED,
    label: "Hubspot On Dark Background",
    fields: _object_spread_props(_object_spread({}, HubspotContactFormFields), {
        LeftSideContent: {
            type: FIELD_TYPES.NESTED,
            label: "Left Side Content",
            fields: {
                title: {
                    type: FIELD_TYPES.TEXT,
                    label: "Title"
                },
                valuesList: {
                    type: FIELD_TYPES.MULTIPLE_NESTED,
                    label: "Values List",
                    nestedConfig: {
                        type: FIELD_TYPES.NESTED,
                        fields: {
                            value: {
                                type: FIELD_TYPES.TEXT,
                                label: "Value"
                            }
                        }
                    }
                },
                textUnderSeparator: {
                    type: FIELD_TYPES.TEXT,
                    label: "Text Under Separator"
                },
                bottomSectionType: {
                    type: FIELD_TYPES.COMBO,
                    label: "Bottom Section Type",
                    options: [
                        {
                            value: "Quote",
                            text: "Quote"
                        },
                        {
                            value: "Social Proof",
                            text: "Social Proof"
                        }
                    ]
                },
                customerQuote: {
                    type: FIELD_TYPES.NESTED,
                    label: "customerQuote",
                    fields: {
                        quote: {
                            type: FIELD_TYPES.TEXT,
                            label: "Quote"
                        },
                        name: {
                            type: FIELD_TYPES.TEXT,
                            label: "Name"
                        },
                        jobDescription: {
                            type: FIELD_TYPES.TEXT,
                            label: "Job Description"
                        },
                        companyName: {
                            type: FIELD_TYPES.TEXT,
                            label: "Company Name"
                        },
                        facePicture: {
                            type: FIELD_TYPES.GALLERY,
                            label: "Face Picture"
                        }
                    }
                },
                socialProof: {
                    type: FIELD_TYPES.NESTED,
                    label: "Social Proof",
                    fields: {
                        image: {
                            type: FIELD_TYPES.GALLERY,
                            label: "Image"
                        },
                        quote: {
                            type: FIELD_TYPES.TEXT,
                            label: "Quote"
                        },
                        companyLogo: {
                            type: FIELD_TYPES.GALLERY,
                            label: "Company Logo"
                        }
                    }
                },
                sentenceAboveLogos: {
                    type: FIELD_TYPES.TEXT,
                    label: "Sentence Above Logos"
                },
                logos: {
                    type: FIELD_TYPES.MULTIPLE_NESTED,
                    label: "Logos",
                    nestedConfig: {
                        type: FIELD_TYPES.NESTED,
                        fields: _object_spread({}, AssetFieldsConfig.image.fields)
                    }
                }
            }
        }
    })
};
